import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, ShieldCheckIcon, FileTextIcon, StarIcon, SparklesIcon, GiftIcon, ClockIcon, ArrowDownIcon, FlameIcon, ArrowRightIcon } from 'lucide-react';
export function PricingSection() {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('es-AR', {
      style: 'currency',
      currency: 'ARS',
      maximumFractionDigits: 0
    }).format(price);
  };
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const valueItems = [{
    name: 'Tomo 1: Diagnóstico de Puertas Abiertas',
    value: 8000
  }, {
    name: 'Tomo 2: Protocolo de Limpieza',
    value: 8000
  }, {
    name: 'Tomo 3: Blindaje del Hogar',
    value: 8000
  }, {
    name: 'Tomo 4: Desbloqueo Financiero',
    value: 8000
  }, {
    name: 'Tomo 5: Salud y Vitalidad',
    value: 8000
  }, {
    name: 'Tomo 6: Sostenimiento de la Victoria',
    value: 8000
  }];
  const bonusItems = [{
    name: 'Mapa Express de Puertas Abiertas',
    value: 5000
  }, {
    name: "Kit de Limpieza 'Casa en Orden'",
    value: 4000
  }, {
    name: "Guión 'Mi Familia No Cree'",
    value: 5000
  }, {
    name: "Plan Anti-Retroceso '7 Días de Reset'",
    value: 5000
  }, {
    name: "Pack de Carteles 'Declaraciones'",
    value: 4000
  }];
  const oroExclusiveItems = [{
    name: 'Archivo de Decretos de Emergencia (Edición Oro)',
    value: 15000
  }, {
    name: 'Protocolos por tipo de crisis',
    value: 8000
  }, {
    name: 'Biblioteca de 100 decretos cortos',
    value: 6000
  }];
  const baseValue = valueItems.reduce((s, i) => s + i.value, 0) + bonusItems.reduce((s, i) => s + i.value, 0);
  const oroExclusiveValue = oroExclusiveItems.reduce((s, i) => s + i.value, 0);
  return <section id="pricing" className="py-12 md:py-24 px-4 bg-secondary-bg relative" data-id="element-233">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-234">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-10" data-id="element-235">
          <h2 className="font-heading text-2xl sm:text-3xl md:text-5xl font-bold text-text-primary mb-2 md:mb-3" data-id="element-236">
            Accedé Hoy al Sistema Completo
          </h2>
          <p className="text-text-secondary text-sm md:text-lg font-body-serif" data-id="element-237">
            Todo lo que necesitás para restaurar tu hogar, tu mente y tu paz.
          </p>
        </motion.div>

        {/* Countdown Timer */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-6 md:mb-8" data-id="element-238">
          <ClockIcon className="w-4 h-4 md:w-5 md:h-5 text-red-600" data-id="element-239" />
          <span className="text-xs md:text-sm font-bold text-red-600 uppercase tracking-wider" data-id="element-240">
            Esta oferta expira en:
          </span>
          <div className="flex gap-1" data-id="element-241">
            {[{
            val: pad(timeLeft.hours),
            label: 'h'
          }, {
            val: pad(timeLeft.minutes),
            label: 'm'
          }, {
            val: pad(timeLeft.seconds),
            label: 's'
          }].map((t, i) => <span key={i} className="bg-text-primary text-white font-mono font-bold text-sm md:text-base px-2 py-1 rounded" data-id="element-242">
                {t.val}
                {t.label}
              </span>)}
          </div>
        </div>

        {/* ========== SHARED VALUE STACK (Both packs include this) ========== */}
        <div className="bg-card-bg rounded-2xl md:rounded-3xl border border-border-gold shadow-sm p-4 md:p-6 mb-4 md:mb-6" data-id="element-243">
          <p className="text-center text-xs md:text-sm font-bold text-text-secondary uppercase tracking-wider mb-4" data-id="element-244">
            Ambos planes incluyen:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6" data-id="element-245">
            {/* Tomos */}
            <div className="mb-3 md:mb-0" data-id="element-246">
              <h4 className="font-bold text-[10px] md:text-xs text-text-primary uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-247">
                <SparklesIcon className="w-3.5 h-3.5 text-gold" data-id="element-248" /> 6 Tomos
              </h4>
              <div className="space-y-1" data-id="element-249">
                {valueItems.map((item, idx) => <div key={idx} className="flex items-center justify-between py-1 border-b border-border-gold last:border-0" data-id="element-250">
                    <div className="flex items-center gap-1.5" data-id="element-251">
                      <CheckIcon className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-252" />
                      <span className="text-[11px] md:text-xs text-text-primary" data-id="element-253">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-[10px] md:text-xs text-text-muted line-through whitespace-nowrap ml-2" data-id="element-254">
                      {formatPrice(item.value)}
                    </span>
                  </div>)}
              </div>
            </div>

            {/* Bonos */}
            <div data-id="element-255">
              <h4 className="font-bold text-[10px] md:text-xs text-text-primary uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-256">
                <GiftIcon className="w-3.5 h-3.5 text-gold" data-id="element-257" /> 6 Bonos
              </h4>
              <div className="space-y-1" data-id="element-258">
                {bonusItems.map((item, idx) => <div key={idx} className="flex items-center justify-between py-1 border-b border-border-gold last:border-0" data-id="element-259">
                    <div className="flex items-center gap-1.5" data-id="element-260">
                      <CheckIcon className="w-3.5 h-3.5 text-green-600 shrink-0" data-id="element-261" />
                      <span className="text-[11px] md:text-xs text-text-primary" data-id="element-262">
                        {item.name}
                      </span>
                    </div>
                    <span className="text-[10px] md:text-xs text-text-muted line-through whitespace-nowrap ml-2" data-id="element-263">
                      {formatPrice(item.value)}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="text-center mt-3 pt-3 border-t border-border-gold" data-id="element-264">
            <p className="text-[10px] md:text-xs text-text-muted" data-id="element-265">
              Valor total del contenido compartido:{' '}
              <span className="line-through font-bold" data-id="element-266">
                {formatPrice(baseValue)}
              </span>
            </p>
          </div>
        </div>

        {/* ========== TWO PRICING CARDS SIDE BY SIDE ========== */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mb-6 md:mb-10" data-id="element-267">
          {/* PACK BASE — First */}
          <div className="bg-card-bg rounded-2xl border border-border-gold p-5 md:p-6 shadow-sm flex flex-col" data-id="element-268">
            <h3 className="font-heading text-lg md:text-xl font-bold text-text-primary mb-1 text-center" data-id="element-269">
              Pack Base
            </h3>
            <p className="text-text-secondary text-xs md:text-sm mb-4 text-center" data-id="element-270">
              Código de Restauración 24/7
            </p>

            <div className="space-y-2 mb-4 flex-grow" data-id="element-271">
              {['6 Tomos PDF completos', '6 Bonos incluidos', 'Acceso inmediato y de por vida'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-272">
                  <CheckIcon className="w-4 h-4 text-gold shrink-0" data-id="element-273" />
                  <span className="text-xs md:text-sm text-text-primary" data-id="element-274">
                    {item}
                  </span>
                </div>)}
            </div>

            <div className="text-center mb-4" data-id="element-275">
              <p className="text-xs text-text-muted line-through mb-0.5" data-id="element-276">
                {formatPrice(baseValue)}
              </p>
              <p className="text-3xl md:text-4xl font-bold text-text-primary" data-id="element-277">
                {formatPrice(19990)}
              </p>
              <p className="text-[10px] md:text-xs text-text-muted" data-id="element-278">
                Pago único • Acceso de por vida
              </p>
            </div>

            <button className="w-full py-3 md:py-3.5 rounded-xl text-gold font-bold border-2 border-gold hover:bg-gold/5 transition-colors tracking-wide text-sm md:text-base mt-auto" data-id="element-279">
              ELEGIR PACK BASE
            </button>
          </div>

          {/* PACK ORO — Second, highlighted */}
          <div className="bg-card-bg rounded-2xl border-2 border-gold p-5 md:p-6 shadow-[0_8px_30px_-10px_rgba(184,134,11,0.25)] flex flex-col relative" data-id="element-280">
            {/* Badge */}
            <div className="flex justify-center mb-3" data-id="element-281">
              <div className="bg-gold text-white px-3 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-wider flex items-center gap-1 shadow-md" data-id="element-282">
                <StarIcon className="w-3 h-3 fill-white" data-id="element-283" /> MÁS ELEGIDO
              </div>
            </div>

            <h3 className="font-heading text-lg md:text-xl font-bold text-gold-bright mb-1 text-center" data-id="element-284">
              Pack Especial Oro
            </h3>
            <p className="text-text-secondary text-xs md:text-sm mb-3 text-center" data-id="element-285">
              Todo lo del Base + Archivo de Decretos
            </p>

            {/* What's extra in Oro */}
            <div className="bg-gold/5 border border-gold/20 rounded-lg p-3 mb-4" data-id="element-286">
              <h4 className="font-bold text-[10px] md:text-xs text-gold uppercase tracking-wider mb-2 flex items-center gap-1.5" data-id="element-287">
                <FlameIcon className="w-3.5 h-3.5" data-id="element-288" /> Exclusivo Pack Oro
              </h4>
              {oroExclusiveItems.map((item, idx) => <div key={idx} className="flex items-center justify-between py-1 border-b border-gold/10 last:border-0" data-id="element-289">
                  <div className="flex items-center gap-1.5" data-id="element-290">
                    <CheckIcon className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-291" />
                    <span className="text-[11px] md:text-xs text-text-primary font-medium" data-id="element-292">
                      {item.name}
                    </span>
                  </div>
                  <span className="text-[10px] md:text-xs text-text-muted line-through whitespace-nowrap ml-2" data-id="element-293">
                    {formatPrice(item.value)}
                  </span>
                </div>)}
            </div>

            <div className="space-y-1.5 mb-4 flex-grow" data-id="element-294">
              <div className="flex items-center gap-2 text-xs md:text-sm text-text-secondary" data-id="element-295">
                <ArrowRightIcon className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-296" />
                <span data-id="element-297">Todo lo del Pack Base incluido</span>
              </div>
              <div className="flex items-center gap-2 text-xs md:text-sm text-text-secondary" data-id="element-298">
                <ArrowRightIcon className="w-3.5 h-3.5 text-gold shrink-0" data-id="element-299" />
                <span data-id="element-300">Protocolos para momentos de crisis</span>
              </div>
            </div>

            <div className="text-center mb-4" data-id="element-301">
              <div className="flex items-center justify-center gap-2 mb-0.5" data-id="element-302">
                <p className="text-xs text-text-muted line-through" data-id="element-303">
                  {formatPrice(baseValue + oroExclusiveValue)}
                </p>
                <span className="bg-green-100 text-green-800 text-[9px] md:text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-304">
                  Ahorrás {formatPrice(baseValue + oroExclusiveValue - 27990)}
                </span>
              </div>
              <p className="text-3xl md:text-4xl font-bold text-text-primary" data-id="element-305">
                {formatPrice(27990)}
              </p>
              <p className="text-[10px] md:text-xs text-text-muted" data-id="element-306">
                Pago único • Acceso de por vida
              </p>
            </div>

            <button className="btn-cta-pulse w-full py-3 md:py-3.5 rounded-xl text-sm md:text-base tracking-wide font-bold mt-auto" data-id="element-307">
              🔥 QUIERO EL PACK ORO
            </button>

            <p className="text-[9px] md:text-[10px] text-center text-text-muted mt-2 italic" data-id="element-308">
              Para cuando la tormenta llega y no querés improvisar.
            </p>
          </div>
        </div>

        {/* Trust Badges */}
        <div className="text-center" data-id="element-309">
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-6 text-text-secondary text-xs md:text-sm mb-3" data-id="element-310">
            <div className="flex items-center gap-1.5 bg-card-bg px-3 py-1.5 rounded-full border border-border-gold shadow-sm" data-id="element-311">
              <LockIcon className="w-3.5 h-3.5 text-gold" data-id="element-312" /> Pago seguro
            </div>
            <div className="flex items-center gap-1.5 bg-card-bg px-3 py-1.5 rounded-full border border-border-gold shadow-sm" data-id="element-313">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-gold" data-id="element-314" /> Garantía 7
              días
            </div>
            <div className="flex items-center gap-1.5 bg-card-bg px-3 py-1.5 rounded-full border border-border-gold shadow-sm" data-id="element-315">
              <FileTextIcon className="w-3.5 h-3.5 text-gold" data-id="element-316" /> Acceso
              inmediato
            </div>
          </div>
          <p className="text-[10px] md:text-xs text-text-muted" data-id="element-317">
            Descarga digital • PDF • Empezás en 10 minutos
          </p>
        </div>
      </div>
    </section>;
}